import styled from "styled-components";
import { DeviceType } from "utils/hooks/useDeviceHook";

const getSuccessMessageModalDeviceWidth = (deviceType: DeviceType): string => {
  if (deviceType === "mobile") return "calc(100% - 10px);";
  return "432px";
};

export const SuccessMessageWrapper = styled.div<{
  deviceType: DeviceType;
}>`
  width: ${({ deviceType }) => getSuccessMessageModalDeviceWidth(deviceType)};
  height: auto;
  background: white;
  border-radius: 16px;
  text-align: center;
  box-shadow: 0 3px 7px rgba(0, 0, 0, 0.3);
`;

export const SuccessContainer = styled.div`
  text-align: center;
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 450px;
  margin: 0 auto;
`;

export const IconContainer = styled.div`
  margin-bottom: 12px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

export const ErrorMessage = styled.div`
  background: #ffebee;
  border: 1px solid #e57373;
  border-radius: 4px;
  padding: 12px 16px;
  margin-bottom: 16px;
  color: #c62828;
  font-size: 14px;
  font-weight: 500;
`;
